import { API, ApiUrls, constructApiUrl } from '../../../api/apis.config'
import { EmailModal } from '../common/email-modal'

type Props = {
  enrollmentId: number
  isConfirmed: boolean
  isOpen: boolean
  closeModal: () => void
  onSuccess?: () => void
}

// Shown right after LEC cancels a bulletin: LEC chooses whether the parents get their cancellation
// email, and may also notify LEC members with a message
export function CancelEnrollmentNotificationModal({
  enrollmentId,
  isConfirmed,
  isOpen,
  closeModal,
  onSuccess
}: Props) {
  return (
    // keyed by enrollment so each cancellation opens with the parents option ticked again
    <EmailModal<{ notifyParents: boolean }>
      key={enrollmentId}
      emailApiEndpoint={
        constructApiUrl(API.enrollments.sendCancelNotification.url, {
          id: enrollmentId
        }) as ApiUrls
      }
      customCheckbox={{
        label: isConfirmed
          ? "Prévenir les parents : email « BI - confirmation d'annulation du séjour par LEC une fois le séjour confirmé » (Brevo n°163)"
          : "Prévenir les parents : email d'annulation d'un BI non confirmé (Brevo n°138)",
        defaultChecked: true
      }}
      optionalContent
      label="Vous venez d'annuler un bulletin. Souhaitez-vous prévenir les parents ? Vous pouvez aussi notifier des membres de l'équipe LEC avec un message."
      isOpen={isOpen}
      closeModal={closeModal}
      onSuccess={onSuccess}
      beforeSubmit={(input, notifyParents) => ({ ...input, notifyParents })}
    />
  )
}
